import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Input,
  makeStyles,
  tokens
} from "@fluentui/react-components";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { IAppFeaturesActivityDataGrid } from "./IAppFeaturesActivityDataGrid";

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingHorizontalL,
  },
  actions: {
    marginTop: tokens.spacingVerticalL,
  }
});

export const AppFeaturesActivityDialog: React.FC<{
  open: boolean,
  setOpen: (value: boolean) => void,
  item: IAppFeaturesActivityDataGrid,
  onUpdate: (item: IAppFeaturesActivityDataGrid) => void
}
> = ({ open, setOpen, item, onUpdate }) => {
  const intl = useIntl();
  const classes = useStyles();

  const [localItem, setLocalItem] = useState<IAppFeaturesActivityDataGrid>(item);
  const [hasError, setHasError] = useState(true);

  const handleInputChange = (field: keyof IAppFeaturesActivityDataGrid, value: string) => {
    const updatedItem = { ...localItem, [field]: value };
    setLocalItem(updatedItem);
    setHasError(!updatedItem.type || !updatedItem.description || !updatedItem.templateText);
  };

  const onConfirm = () => {
    onUpdate(localItem);
    setOpen(false)
  }


  return (
    <Dialog open={open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {intl.formatMessage({ defaultMessage: "Add a tab to your personal app" })}
          </DialogTitle>
          <DialogContent className={classes.container}>
            <Field label={intl.formatMessage({ defaultMessage: "Type (unique Graph API call identifier that isn't visible to users)" })} required>
              <Input
                placeholder={intl.formatMessage({ defaultMessage: "Enter an activity identifier" })}
                value={localItem.type || ""}
                onChange={(e) => handleInputChange("type", e.target.value)}
              />
            </Field>
            <Field label={intl.formatMessage({ defaultMessage: "Description (for example, 'Work item requires your approval.')" })} required>
              <Input
                placeholder={intl.formatMessage({ defaultMessage: "Enter a description" })}
                value={localItem.description || ""}
                onChange={(e) => handleInputChange("description", e.target.value)}
              />
            </Field>
            <Field label={intl.formatMessage({ defaultMessage: "Title (for example, '{actor} assigned you {workItemId}')" })} required>
              <Input
                placeholder={intl.formatMessage({ defaultMessage: "Enter a title" })}
                value={localItem.templateText || ""}
                onChange={(e) => handleInputChange("templateText", e.target.value)}
              />
            </Field>
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button appearance="secondary" onClick={() => { setOpen(false) }}>
              {intl.formatMessage({ defaultMessage: "Cancel" })}
            </Button>
            <Button disabled={hasError} appearance="primary" onClick={onConfirm}>
              {intl.formatMessage({ defaultMessage: "Confirm" })}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog >
  );
}

